
export enum ActionMode {
    view = 0,
    edit = 1,
    add = 2,
    empty = 3
}

export enum PageAction {
    edit = 0,
    delete = 1,
    save = 2,
    cancel = 3
}
